import styled from "styled-components/macro";

import TabSelector from "components/TabSelector";

const MobileTransactionSaleTabSelector = styled(TabSelector)`
  text-transform: none;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  padding: ${({ theme }) => theme.space[2]}px;
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ selected, color, theme }) => {
    const borderHeight = selected ? "3px" : "2px";
    return `
      font-weight: ${selected ? "400" : "300"};
      margin-left: ${theme.space[3]}px;
      border-bottom: ${borderHeight} solid ${
        selected ? theme.colors[color] || theme.colors.primary : "transparent"
      };
    `;
  }};
`;

export default MobileTransactionSaleTabSelector;
